import React from 'react';
import _ from 'lodash';
import { SkillDisplay, SkillIcon } from './SkillDisplay';
import Select from 'react-select';
import {FilterPanel} from './OptionsPanel'
export class Table extends React.Component{
    skillNames = [];
    areaNames = [];
    diffNames = [];
    constructor(props){
        super(props);
        this.state = {
            tasksToDisplay: props.tasks
        }
        this.skillNames = _.uniq(props.tasks.flatMap(x => Object.keys(x.skills)));
        this.skillNames.sort();
        this.areaNames = _.uniq(props.tasks.map(x => x.area));
        this.areaNames.sort();
        this.diffNames = _.uniq(props.tasks.map(x => x.difficulty));
        this.diffNames.sort();
        this.updateList();
    }
    filter(tasks){
        const {filter} = this.props;
        const {name, desc, area, diff, complete, skill} = filter;
        const completeBool = complete !== undefined ? complete == 'true' : undefined;
        if(name && name.length){
            tasks = tasks.filter(x => x.name.toLowerCase().indexOf(name.toLowerCase()) > -1); 
        }
        if(desc && desc.length){
            tasks = tasks.filter(x => x.desc.toLowerCase().indexOf(desc.toLowerCase()) > -1); 
        }
        if(diff && diff.length){
            tasks = tasks.filter(x => diff.indexOf(x.difficulty) > -1); 
        }
        if(completeBool !== undefined && completeBool !== null){
            tasks = tasks.filter(x => {
                if(completeBool){
                    return this.props.playerTasks.indexOf(+x.id) > -1
                } else {
                    return this.props.playerTasks.indexOf(+x.id) == -1;
                }
            }); 
        }
        if(skill && skill.length){
            tasks = tasks.filter(x => skill.find(s => x.skills[s] !== undefined)); 
        }
        
        if(area && area.length){
            let areaCopy = area;
            var unlockedIndex = areaCopy.indexOf("Unlocked");
            if(unlockedIndex > -1){
                areaCopy = areaCopy.filter(x => x !== "Unlocked");
                areaCopy = [...areaCopy, ...this.props.unlockedAreas]
            }
            tasks = tasks.filter(x => areaCopy.indexOf(x.area) > -1); 
        }
        return tasks;
    }
    updateList(){
        
        var tl = this.props.tasks;
        var filtered = this.filter(tl);
        var ordered = this.order(filtered);
        this.setState({tasksToDisplay: ordered});
    }
    componentDidUpdate(props){
        if(props.tasks !== this.props.tasks){
            this.updateList();
            return;
        }
        if(props.unlockedAreas !== this.props.unlockedAreas){
            this.updateList();
            return;
        }
        if(props.filter !== this.props.filter){
            this.updateList();
            return;
        }
        if(props.ord !== this.props.ord){
            this.updateList();
            return;
        }
    }
    order(tasks){
        var tasksCopy = [...tasks];
        var {key, desc} = this.props.ord;
        tasksCopy.sort((a, b) => {

            // a > b -> 1
            // a < b -> -1

            var aVal = a[key];
            var bVal= b[key];
            if(aVal.toLowerCase){
                aVal = aVal.toLowerCase();
                bVal = bVal.toLowerCase();
            }
            if(key == 'difficulty'){
                switch(aVal){
                    case 'easy':
                        aVal = 1;
                        break;
                    case 'medium':
                        aVal = 2;
                        break;
                    case 'hard':
                        aVal = 3;
                        break;
                    case 'elite':
                        aVal = 4;
                        break;
                    case 'master':
                        aVal = 5;
                        break;
                }
                switch(bVal){
                    case 'easy':
                        bVal = 1;
                        break;
                    case 'medium':
                        bVal = 2;
                        break;
                    case 'hard':
                        bVal = 3;
                        break;
                    case 'elite':
                        bVal = 4;
                        break;
                    case 'master':
                        bVal = 5;
                        break;
                }
            }
            return aVal > bVal
                ? (desc ? 1 : -1)
                : (desc ? -1 : 1);
        });
        return tasksCopy;
    }
    columnHeaderClick(column){
        let {key, desc} = this.props.ord;
        if(key !== column){
            key = column;
            desc = false;
        } else {
            desc = !desc;
        }
        this.props.ordChange({key, desc});
        this.updateList();
        
    }
    formatDifficulty(diff){
        switch(diff){
            case "easy":
                return "Easy (10)"
            case "medium":
                return "Medium (40)"
            case "hard":
                return "Hard (80)";
            case "elite":
                return "Elite (200)";
            case "master":
                return "Master (400)";
        }
    }
    getDialog(){
        return <div className="modal" tabIndex="-1" role="dialog" id="filters-modal">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h6 className="modal-title">Filters</h6>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <FilterPanel 
                            value={this.props.filter} 
                            onChange={(v, k) => this.filterChange(v, k)}
                            areaNames={this.areaNames}
                            skillNames={this.skillNames}
                            diffNames={this.diffNames}/>
                    </div>
                    <div className="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    }
    filterChange(filter, key){
        this.props.filterChange(filter);
        this.updateList();
    }
    filtersSummary(){
        const {name, desc, area, diff, complete, skill} = this.props.filter;
        const spanStyle={marginLeft: "4px", marginRight: "4px", border: "2px solid black", borderRadius: '4px', padding: "4px", marginBottom: "4px", cursor: 'pointer'};
        const tagClick = (key) => {
            const filterCopy = {...this.props.filter};
            delete filterCopy[key];
            this.props.filterChange(filterCopy);
        }
        const spanProps = {
            style: spanStyle,
            title: 'Remove filter'
        }
        return <div style={{display: 'flex'}}>
            {name && name.length && <span {...spanProps} onClick={() => tagClick('name')}>Name: {name}</span>}
            {desc && desc.length && <span {...spanProps} onClick={() => tagClick('desc')}>Description: {desc}</span>}
            {area && area.length && <span {...spanProps} onClick={() => tagClick('area')}>Area: {area.join(", ")}</span>}
            {diff && diff.length && <span {...spanProps} onClick={() => tagClick('diff')}>Difficulty: {diff.join(", ")}</span>}
            {skill && skill.length && <span {...spanProps} onClick={() => tagClick('skill')}>Skills: {skill.map(x => <SkillIcon skill={x}/>)}</span>}
            {complete !== undefined && <span {...spanProps} onClick={() => tagClick('complete')}>Complete: {complete ? 'Yes' : 'No'}</span>}
        </div>
    }
    // multiselects for the filters, numeric above/below for skills
    render(){
        const clickableStyle = {cursor: 'pointer'};
        return <div style={{marginTop: "8px", display: 'flex', flexDirection: 'column'}} className="table-container">
            <div style={{display: 'flex'}}>
            <i class="bi-filter" data-toggle="modal" data-target="#filters-modal" style={{fontSize: '24px', cursor: 'pointer'}}></i>
            {this.filtersSummary()}
            </div>
            {this.getDialog()}
            <table className="table table-bordered table-sm table-responsive" style={{fontSize: "14px"}}>
            <thead>
                <tr>
                    <th style={{width: '300px', ...clickableStyle}} onClick={() => this.columnHeaderClick('name')}>Name {this.props.ord.key == 'name' ? (this.props.ord.desc ? <i class="bi-chevron-down"></i> : <i class="bi-chevron-up"></i>) : ""}</th>
                    <th onClick={() => this.columnHeaderClick('desc')} style={clickableStyle}>Description {this.props.ord.key == 'desc' ? (this.props.ord.desc ? <i class="bi-chevron-down"></i> : <i class="bi-chevron-up"></i>) : ""}</th>
                    <th >Skills</th>
                    <th onClick={() => this.columnHeaderClick('area')} style={{width: '100px', ...clickableStyle}}>Area {this.props.ord.key == 'area' ? (this.props.ord.desc ? <i class="bi-chevron-down"></i> : <i class="bi-chevron-up"></i>) : ""}</th>
                    <th onClick={() => this.columnHeaderClick('difficulty')} style={{width: '140px', ...clickableStyle}}>Difficulty {this.props.ord.key == 'difficulty' ? (this.props.ord.desc ? <i class="bi-chevron-down"></i> : <i class="bi-chevron-up"></i>) : ""}</th>
                    <th style={{width: "100px"}}>{this.state.tasksToDisplay.length} of {this.props.tasks.length}</th>
                </tr>
            </thead>
            <tbody>
                {this.state.tasksToDisplay.map(t => {
                    var complete = this.props.playerTasks.indexOf(+t.id) > -1 ;
                    return <tr className={complete && "complete"} style={{textAlign: 'left', cursor: 'pointer'}} key={t.id} onClick={() => this.props.personalChange(t)}>
                        <td>{t.name}</td>
                        <td dangerouslySetInnerHTML={{__html: t.desc}}></td>
                        <td><SkillDisplay skills={t.skills} levels={this.props.levels}/></td>
                        <td>{t.area}</td>
                        <td>{this.formatDifficulty(t.difficulty)}</td>
                        <td>
                            <input type="checkbox" checked={t.personal} class="form-control" style={{width: "20px", height: "20px"}}/>
                        </td>
                    </tr>
                })}
            </tbody>
        </table>
        </div>
    }
}